import * as D from './deps';

const deviceProperties = getDeviceProperties();

function getDeviceProperties() {
  const osInfo = D.Utils.ClientInfo.getOSInfo();
  // Expect `osPlatform` value: "Mac_OS", "Windows", "Linux", etc.
  return Object.freeze({
    osPlatform: `${osInfo.name}`.replace(' ', '_'),
    osVersion: osInfo.version,
  });
}

export function getAvailableProducts() {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.GET_AVAILABLE_PRODUCTS,
  });
}

export function getSubscriptionInfoV2() {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.GET_SUBSCRIPTION_INFO_V2,
  });
}

export function getCreditCardV2() {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.GET_CREDIT_CARD_V2,
  });
}

export function updateBillingInfoV2({
  cancelSubscription,
  deleteCreditCard,
  newCreditCardInfo,
  password,
  apld, // cspell:disable-line
  atid, // cspell:disable-line
  tracking,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.UPDATE_BILLING_INFO_V2,
    serviceHostType: D.Constants.Api.ServiceHostTypes.PAID,
    content: {
      cancelSubscription,
      deleteCreditCard,
      newCreditCardInfo,
      password,
      apld, // cspell:disable-line
      atid,
      tracking,
    },
  });
}

export function prepareToAcquirePaypalProduct({
  getSpecialOfferType,
  specialOfferToken,
  vendorSku,
  backingProductIdentifier,
  paymentProvider,
  tierName,
  discountType,
  durationType,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.PREPARE_TO_ACQUIRE_PAYPAL_PRODUCT,
    content: {
      specialOfferType: getSpecialOfferType,
      specialOfferToken,
      vendorSku,
      backingProductIdentifier,
      paymentProvider,
      tierName,
    },
    actionParams: {
      discountType,
      durationType,
    },
  });
}

export function acquireProduct({
  getSpecialOfferType,
  specialOfferToken,
  vendorSku,
  backingProductIdentifier,
  paymentProvider,
  creditCardInfo,
  paypalPurchaseInfo,
  tierName,
  tracking,
  discountType,
  previousTier,
  previousDiscountType,
  atid,
  apld,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.ACQUIRE_PRODUCT,
    serviceHostType: D.Constants.Api.ServiceHostTypes.PAID,
    content: {
      specialOfferType: getSpecialOfferType,
      specialOfferToken,
      vendorSku,
      backingProductIdentifier,
      paymentProvider,
      creditCardInfo,
      paypalPurchaseInfo,
      tracking,
      tierName,
      deviceProperties,
      atid,
      apld,
    },
    actionParams: {
      discountType,
      previousTier,
      previousDiscountType,
    },
  });
}

export function cancelCurrentProduct() {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.CANCEL_CURRENT_PRODUCT,
  });
}

// Family Plan
export function getFamilyPlanRecord() {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.FAMILY_PLAN_GET_RECORD,
  });
}

export function getParentFamilyPlanInfo() {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.FAMILY_PLAN_GET_PARENT_INFO,
  });
}

export function createFamilyPlanInvite({ emailAddress }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.FAMILY_PLAN_CREATE_INVITE,
    content: {
      emailAddress,
    },
  });
}

export function resendFamilyPlanInvite({ emailAddress }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.FAMILY_PLAN_RESEND_INVITE,
    content: {
      emailAddress,
    },
  });
}

export function revokeFamilyPlanInvite({ inviteToken, emailAddress }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.FAMILY_PLAN_REVOKE_INVITE,
    content: {
      inviteToken,
      emailAddress,
    },
  });
}

export function removeChildFromFamilyPlan({ childListenerId, emailAddress }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.FAMILY_PLAN_REMOVE_CHILD,
    content: {
      childListenerID: childListenerId,
      emailAddress,
    },
  });
}

export function exitFromFamilyPlan() {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.FAMILY_PLAN_EXIT,
  });
}

export function getDiscountVerificationInfo({ discountType = null, eRequestId = null }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.GET_DISCOUNT_VERIFICATION_INFO,
    content: {
      discountType,
      eRequestId,
    },
  });
}
